import AboutForm from '../components/layout/About/AboutContent';


function AboutPage() {
  return (
	  <section>
			<AboutForm />
	  </section>
  );
}

export default AboutPage;